import BaseApplication from "pages/BaseApplication"
import DetailsBasel from "./DetailsBasel"
import AssignStaff from "../AssignStaff/index"
import DetailsRotterdam from "./DetailsRotterdam"
import { useEffect, useState } from "react"

import Application from "services/applications/Application.service"

const loggedInUser = JSON.parse(localStorage.getItem("authUser"))
const appService = new Application(loggedInUser)

const ExportLicense = props => {
  const assignApplicationToOfficer = formData => {
    appService.assignStaff(formData).then(response => {
        if (response.status) {
          //console.log(response)
          alert("Officer successfully assigned")
          //props.history.push("/dashboard")
        } else {
          console.log(response)
        }
      })
  }
  const [details, setdetails] = useState()

  useEffect(()=>{
    if(props.appDetails.basel_convention) {
      setdetails(<DetailsBasel appDetails={props.appDetails} />)
    } else {
      setdetails(<DetailsRotterdam appDetails={props.appDetails} />)
    }
  }, [])
  return (
    <BaseApplication
      submit={assignApplicationToOfficer}
      title={"Assign Staff"}
      attachments={props.appDetails.application_attachments}
      formComponent={
        <AssignStaff
        department={props.appDetails.service.department_id}
          appDetails={{
            applicationId: props.appDetails.id,
            assignedBy: loggedInUser.id,
          }}
        />
      }
      applicationData={props.appDetails}
      appDetails={details}
    />
  )
}

export default ExportLicense
